<button style="position: fixed; right: 0px; transform: rotate(-90deg); z-index: 1000;
    transform-origin: bottom right;" (click)="drawerVisible = !drawerVisible" nz-button>Settings</button>
<!-- @if(markerKeys.length > 0){
<button style="position: fixed; right: 0px; transform: rotate(-90deg);
    transform-origin: bottom right;" (click)="drawerVisible = !drawerVisible" nz-button>Settings</button>
} -->
@if(batchService.running() && !drawerVisible){
<div class="batch-pill">
    <span nz-icon nzType="loading" nzSpin></span>
    <div class="batch-pill-text">
        <div class="batch-pill-label">{{ batchService.currentLabel() }}</div>
        <div class="batch-pill-sub">{{ batchService.done() }}/{{ batchService.total() }} · avoid changing the view</div>
    </div>
    <button nz-button nzDanger nzSize="small" (click)="batchService.cancel()">Cancel</button>
</div>
}

<nz-drawer [nzVisible]="drawerVisible" nzPlacement="right" nzTitle="Settings" [nzMask]="true" [nzWidth]="320"
    [nzMaskStyle]="{'background-color': 'transparent'}" (nzOnClose)="drawerVisible=false">
    <div *nzDrawerContent>

        <ng-container [ngTemplateOutlet]="sonicMarkers"></ng-container>
        <ng-container [ngTemplateOutlet]="horizonColors"></ng-container>
        <ng-container [ngTemplateOutlet]="batchScreenshots"></ng-container>
    </div>
</nz-drawer>


<ng-template #sonicMarkers>
    @if(markerKeys.length > 0){
    <div>
        <h1 style="font-size: 18px;">Toggle Sonic Markers</h1>
        <div style="margin-left: 5px; border-bottom: 1px solid #eee;">
            <label nz-checkbox [(ngModel)]="allChecked" (ngModelChange)="onAllChecked($event)"
                [nzIndeterminate]="indeterminate" style="color: #ccc;">
                (Select/Deselect All)
            </label>
        </div>
        <form nz-form [formGroup]="markersVisibilityForm" nzLayout="vertical">
            @for(key of markerKeys; track key){
            <nz-form-item style="margin: 5px;">
                <label nz-checkbox [formControlName]="key">
                    {{key}}
                    <div style="font-size: x-small; color: #ccc;">z: {{markerDepths[key]}}</div>
                </label>
            </nz-form-item>
            }
        </form>
    </div>
    <nz-divider />
}

</ng-template>

<ng-template #horizonColors>
    @if(selectedHorizons().length > 0) {
    <div>
        <h1 style="font-size: 18px;">Horizon Colors</h1>
        @for(horizon of selectedHorizons(); track horizon.id) {
        <div style="display: flex; align-items: center; gap: 8px; margin: 6px 0;">
            <nz-color-picker [nzValue]="horizon.color" [nzDisabledAlpha]="true"
                (nzOnChange)="updateHorizonColor(horizon.id, $event.color.toHexString())">
            </nz-color-picker>
            <span style="color: #555;">{{ horizon.name }}</span>
        </div>
        }
    </div>
    <nz-divider />
    }
</ng-template>

<ng-template #batchScreenshots>
    <div class="batch-section">
        <div class="batch-header" (click)="batchOpen = !batchOpen">
            <h1>Batch Screenshots</h1>
            <span nz-icon nzType="down" class="batch-caret" [class.open]="batchOpen"></span>
        </div>

        @if(batchOpen){
        <p class="batch-hint">
            Flips through the selected jobs, iterations and model properties with the current
            view settings and downloads every capture as one zip. Keeps running if you switch
            to another tab while it captures.
        </p>

        <div class="batch-field">
            <label>Jobs</label>
            <nz-select nzMode="multiple" nzPlaceHolder="Select jobs" nzSize="small"
                [(ngModel)]="batchJobIds" [nzDisabled]="batchService.running()">
                @for(job of projectJobs(); track job.id){
                <nz-option [nzValue]="job.id" [nzLabel]="job.name" />
                }
            </nz-select>
            <div class="batch-quick-actions">
                <button nz-button nzSize="small" (click)="useFavourites()"
                    [disabled]="!favJobsService.hasFavJobs() || batchService.running()">Use favourites</button>
                <button nz-button nzSize="small" (click)="batchJobIds = []"
                    [disabled]="batchJobIds.length === 0 || batchService.running()">Clear</button>
            </div>
        </div>

        <div class="batch-field">
            <label>Model properties</label>
            <nz-select nzMode="multiple" nzSize="small"
                [nzPlaceHolder]="'Current (' + currentModelId + ')'"
                [(ngModel)]="batchModels" [nzDisabled]="batchService.running()">
                @for(model of availableModels; track model.id){
                <nz-option [nzValue]="model.id" [nzLabel]="model.name" />
                }
            </nz-select>
        </div>

        <div class="batch-field">
            <label>Views</label>
            <div class="batch-views">
                <label nz-checkbox [(ngModel)]="batchTargets.full"
                    [nzDisabled]="batchService.running()">Full grid</label>
                <label nz-checkbox [(ngModel)]="batchTargets.inline"
                    [nzDisabled]="batchService.running()">Inline</label>
                <label nz-checkbox [(ngModel)]="batchTargets.crossline"
                    [nzDisabled]="batchService.running() || is2d">Crossline</label>
                <label nz-checkbox [(ngModel)]="batchTargets.depth"
                    [nzDisabled]="batchService.running() || is2d">Depth</label>
            </div>
        </div>

        <div class="batch-field">
            <label>Iterations</label>
            <nz-radio-group class="batch-iterations" [(ngModel)]="batchIterationMode"
                [nzDisabled]="batchService.running()">
                <label nz-radio nzValue="last">Last</label>
                <label nz-radio nzValue="first-last">First & last</label>
                <label nz-radio nzValue="first">First</label>
                <label nz-radio nzValue="custom">Specific</label>
            </nz-radio-group>
            @if(batchIterationMode === 'custom'){
            <input nz-input nzSize="small" placeholder="e.g. 0, 10, 25"
                [(ngModel)]="batchCustomIterations" [disabled]="batchService.running()" />
            }
        </div>

        @if(!batchService.running()){
        <button nz-button nzType="primary" class="batch-start" (click)="startBatch()"
            [disabled]="batchCount === 0">
            Capture {{ batchCount }} screenshot{{ batchCount === 1 ? '' : 's' }}
        </button>
        } @else {
        <div class="batch-progress">
            <nz-progress [nzPercent]="batchPercent" nzSize="small" />
            <div class="batch-progress-label">
                {{ batchService.currentLabel() }} ({{ batchService.done() }}/{{ batchService.total() }})
            </div>
            <button nz-button nzDanger nzSize="small" class="batch-start"
                (click)="batchService.cancel()">Cancel</button>
        </div>
        }
        }
    </div>
</ng-template>